export default props => (
  <div className='quote-content mt-10'>
    <blockquote>
      {props.children}
    </blockquote>
  </div>
)
